var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsappIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_523_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99999 0.799988C4.92719 0.799988 0.799986 4.92719 0.799986 9.99999C0.799986 11.584 1.20919 13.1416 1.98519 14.516L0.814786 18.692C0.776386 18.8292 0.813586 18.9764 0.912786 19.0784C0.989186 19.1572 1.09319 19.2 1.19999 19.2C1.23199 19.2 1.26439 19.196 1.29599 19.1884L5.65439 18.1088C6.98519 18.8232 8.48399 19.2 9.99999 19.2C15.0728 19.2 19.2 15.0728 19.2 9.99999C19.2 4.92719 15.0728 0.799988 9.99999 0.799988ZM14.628 13.2464C14.4312 13.7912 13.4872 14.2884 13.0336 14.3552C12.6264 14.4148 12.1112 14.4404 11.5456 14.2628C11.2028 14.1548 10.7628 14.0116 10.1992 13.7712C7.82999 12.7608 6.28279 10.4052 6.16439 10.2496C6.04639 10.094 5.19999 8.98519 5.19999 7.83759C5.19999 6.68999 5.80999 6.12559 6.02679 5.89199C6.24359 5.65839 6.49919 5.59999 6.65679 5.59999C6.81439 5.59999 6.97159 5.60199 7.10959 5.60839C7.25479 5.61559 7.44959 5.55359 7.64119 6.00879C7.83799 6.47599 8.31039 7.62359 8.36879 7.74079C8.42799 7.85759 8.46719 7.99399 8.38879 8.14959C8.31039 8.30519 8.27119 8.40239 8.15279 8.53879C8.03439 8.67519 7.90479 8.84279 7.79839 8.94759C7.67999 9.06399 7.55719 9.18999 7.69479 9.42359C7.83239 9.65719 8.30639 10.4208 9.00879 11.0392C9.91079 11.8336 10.672 12.08 10.908 12.1968C11.144 12.3136 11.282 12.294 11.4196 12.1384C11.5572 11.9824 12.01 11.4572 12.1672 11.224C12.3244 10.9908 12.482 11.0292 12.6988 11.1072C12.9156 11.1848 14.0768 11.7488 14.3128 11.8656C14.5488 11.9824 14.7064 12.0408 14.7656 12.138C14.8248 12.2348 14.8248 12.702 14.628 13.2464Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_523_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappIcon);
export default __webpack_public_path__ + "static/media/whatsapp_icon.8f267f8d8f59c6f004b5365321e6a19d.svg";
export { ForwardRef as ReactComponent };